/** Created by azhou on 2019/3/14.*/
<template>
    <div class="blank_space">
      <public-title>{{editData ? '编辑发票' : '添加发票'}}
        <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
      </public-title>
      <!--发票类型-->
      <div class="border-bottom mb-5 pb-5">
        <h4 class="text-left p-3 font-weight-bold bg-muted">发票类型</h4>
        <div class="d-flex justify-content-between w-25 m-auto pt-4">
          <el-button class="choose-type" :class="{'active':commonInvoice}" @click="commonInvoice=true">增值税普通发票</el-button>
          <el-button class="choose-type" :class="{'active':!commonInvoice}" @click="commonInvoice=false">增值税专用发票</el-button>
        </div>
      </div>
      <!--发票抬头-->
      <div class="border-bottom mb-5 pb-5" v-if="commonInvoice">
        <h4 class="text-left p-3 font-weight-bold mb-4 bg-muted">发票抬头</h4>
        <div class="d-flex flex-column w-100 align-items-center pt-4">
          <span class="text-muted mb-2">普通发票的抬头可以是个人姓名或者公司名称</span>
          <el-input class="w-50" placeholder="请输入发票抬头..." v-model="invoiceInfo.rise"/>
        </div>
      </div>
      <!--增值税专用发票_公司信息-->
      <div class="border-bottom mb-4 pb-4" v-if="!commonInvoice">
        <h4 class="text-left p-3 rounded font-weight-bold mb-4 bg-muted">公司信息</h4>
        <left-text-border leftText="名称" class="w-50 m-auto mb-2"
                          placeholder="请输入营业执照上的公司名称..." v-model="invoiceInfo.corporate_name"/>
        <left-text-border leftText="地址" class="w-50 m-auto mb-2"
                          placeholder="请输入营业执照上的公司地址..." v-model="invoiceInfo.address"/>
        <left-text-border leftText="电话" class="w-50 m-auto"
                          placeholder="请输入公司固定电话..." v-model.trim="invoiceInfo.corporate_mobile"/>
      </div>
      <!--增值税专用发票_开户信息-->
      <div class="border-bottom mb-4 pb-4" v-if="!commonInvoice">
        <h4 class="text-left p-3 rounded font-weight-bold mb-4 bg-muted">开户信息</h4>
        <left-text-border leftText="开户银行" class="w-50 m-auto mb-2"
                          placeholder="请输入开户许可证上的开户银行（精确到支行）..." v-model="invoiceInfo.opening_bank"/>
        <left-text-border leftText="开户账号" class="w-50 m-auto"
                          placeholder="请输入公司开户许可证上的银行账户..." v-model="invoiceInfo.account_number"/>
      </div>
      <!--纳税信息-->
      <div class="border-bottom mb-4 pb-4">
        <h4 class="text-left p-3 rounded font-weight-bold mb-4 bg-muted">纳税信息</h4>
        <div class="d-flex flex-column w-100 align-items-center pt-4">
          <span class="text-muted mb-2">纳税人识别号 / 统一社会信用代码</span>
          <el-input class="w-50" placeholder="15位的纳税人识别号或18位的社会信用代码..." v-model="invoiceInfo.duty_paragraph"/>
        </div>
        <div class="text-left mt-5">
          <span class="text-muted">据《国家税务总局关于增值税发票开具有关问题的公告》，自2017年7月1日起，企业购买索取增值税普通发票时，应向销售方提供纳税人识别号或统一社会信用代码，否则不得作为税收凭证。</span>
        </div>
      </div>
      <!--收件信息-->
      <div class="border-bottom mb-4 pb-4">
        <h4 class="text-left p-3 rounded font-weight-bold mb-4 bg-muted">收件信息</h4>
        <left-text-border leftText="收件姓名" class="w-50 m-auto mb-2"
                          placeholder="请输入收件人姓名..." v-model="invoiceInfo.addressee"/>
        <left-text-border leftText="联系方式" class="w-50 m-auto mb-2"
                          placeholder="请输入手机号或者座机号..." v-model.trim="invoiceInfo.mobile"/>
        <left-text-border leftText="收件地址" class="w-50 m-auto"
                          placeholder="请输入具体收件地址..." v-model="invoiceInfo.receiving_address"/>
      </div>
      <el-button type="primary" @click="addInvoiceInfo">提交</el-button>
    </div>
</template>

<script>
  import { mapGetters,mapMutations, mapActions } from 'vuex'

  export default {
    name: 'addInvoice',
    computed: {
      ...mapGetters(['storeInfo']),
      storeId() { return this.$route.query.store },
      editData () { return this.$route.query.item }
    },
    data() {
      return {
        commonInvoice: true,
        invoiceInfo:{},
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.storeId})
      if (this.editData) { 
        this.invoiceInfo = this.editData
        if (!this.editData.rise) this.commonInvoice = false
      }
    },
    destroyed() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['addStoreInvoice']),
      addInvoiceInfo() {
        this._confirm('确定提交信息么？',() => {
          if (this.editData) this.addStoreInvoice({data: this.invoiceInfo, edit: 1})
          else this.addStoreInvoice({data: this.invoiceInfo, edit: 0})
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .choose-type{
    border: 1px solid #17a2b8;
    color: #17a2b8;
    &.active{
      color: #fff;
      background-color: #17a2b8;
    }
  }
</style>
